"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageWrapper = void 0;
const react_1 = __importDefault(require("react"));
const breadCrumbs_1 = require("@geome/react-components-next/lib/components/breadCrumbs");
const images_1 = require("../../assets/images");
const header_1 = require("../header");
const buttonLink_1 = require("@geome/react-components-next/lib/components/buttonLink");
const footerLinks_1 = require("../footerLinks");
require("@fontsource/roboto");
require("@fontsource/roboto/700.css");
const singleBreadcrumb_1 = require("../singleBreadcrumb");
const useMatchMedia_1 = require("@geome/react-next/lib/hooks/useMatchMedia");
const PageWrapper = ({ titleText, subTitleText, breadcrumbs, children, stationLocatorLink, bannerImageSrc = images_1.ShellBannerImage, darkBannerImageSrc = images_1.ShellBannerImageDark, headerLinks, headerLocaleLinks, }) => {
    const darkMode = (0, useMatchMedia_1.useMatchMedia)("(prefers-color-scheme: dark)");
    const bannerSrc = darkMode ? darkBannerImageSrc : bannerImageSrc;
    return (react_1.default.createElement("div", { className: "page", "data-testid": "full-page" },
        react_1.default.createElement("div", { className: "page__header" },
            react_1.default.createElement(header_1.Header, { links: headerLinks, localeLinks: headerLocaleLinks })),
        react_1.default.createElement("div", { className: "page__header-breadcrumbs" },
            react_1.default.createElement(breadCrumbs_1.Breadcrumbs, { breadcrumbs: breadcrumbs, seperatorStyle: "chevrons", renderAfter: () => (react_1.default.createElement(buttonLink_1.ButtonLink, { translationToken: "buttons.station_locator", href: stationLocatorLink })) })),
        react_1.default.createElement("div", { className: "page__banner" },
            react_1.default.createElement("img", { className: "page__banner-image", role: "presentation", src: bannerSrc }),
            react_1.default.createElement("div", { className: "page__banner-info" },
                react_1.default.createElement("h1", { className: "page__banner-info-title", id: "main-title" }, titleText),
                react_1.default.createElement("p", { className: "page__banner-info-sub-title" }, subTitleText))),
        breadcrumbs.length > 1 && (react_1.default.createElement("div", { className: "page__back-button" },
            react_1.default.createElement(singleBreadcrumb_1.SingleBreadcrumb, { breadcrumbs: breadcrumbs }))),
        react_1.default.createElement("div", { className: "page__main-section" },
            react_1.default.createElement("div", { className: "page__main-section-inner" }, children)),
        react_1.default.createElement("div", { className: "page__footer-breadcrumbs" },
            react_1.default.createElement(breadCrumbs_1.Breadcrumbs, { breadcrumbs: breadcrumbs, seperatorStyle: "chevrons" })),
        react_1.default.createElement(footerLinks_1.FooterLinks, null)));
};
exports.PageWrapper = PageWrapper;
